export default __webpack_public_path__ + "static/media/bahanno-logo.98d3bbae.svg";